import {useState, useEffect, useRef} from "react";
import {Carousel, Col, Row} from 'antd';
import ProductHeader from './productPage/productHeader';
import InfoBanner from './infoBanner';
import ModuleHeader from './moduleHeader';
import IndustrySection from './industrySection';
import AdvantageHeader from './advantagePage/advantageHeader';
import AdvantageDisplay from './advantagePage/advantageDisplay';
import ProductCard from './productPage/card';
import PartnersHeader from './partnerPage/partnerHeader';
import PartnerCarousel from './partnerPage/partnerCarousel';
import InsideInfo from './insideInfo';
import VideoPlayerCard from './videoPlayerCard';
import './index.css';
import {useTranslation} from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// 引入数据文件
import productsDefault from './data.js';
import productsEnglish from './data_en.js';
import productsVietnamese from './data_vi.js';
import {gtag_report_home_page_visit} from '../../utils';
import SEO from '../seo';
import { PAGE_SEO, COMMON_KEYWORDS } from '../seo/pageSeo';
import { LANG_PREFIX } from '../../config/siteConfig';


export default function Home() {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [cardHeight, setCardHeight] = useState(0);

    const [products, setProducts] = useState([]);
    const videoRefs = useRef([]);
    useEffect(() => {
        // 当页面加载时，调用谷歌分析首页访问跟踪
        gtag_report_home_page_visit();

        const loadProducts = () => {
            // 根据当前语言设置加载相应的数据
            const lang = i18n.language;
            let productsData;
            if (lang.startsWith('en')) {
                productsData = productsEnglish;
            } else if (lang.startsWith('vi')) {
                productsData = productsVietnamese;
            } else {
                productsData = productsDefault;
            }
            setProducts(productsData);
        };

        loadProducts();
        // 设置卡片高度根据当前语言
        setCardHeight(i18n.language.startsWith('zh') ? 355 : 432);

        // 监听语言变化并更新产品和卡片高度
        const handleLanguageChange = () => {
            const lang = i18n.language;
            let productsData;
            if (lang.startsWith('en')) {
                productsData = productsEnglish;
            } else if (lang.startsWith('vi')) {
                productsData = productsVietnamese;
            } else {
                productsData = productsDefault;
            }
            setProducts(productsData);
            setCardHeight(lang.startsWith('zh') ? 355 : 432);
        };

        // 监听语言变化
        i18n.on('languageChanged', handleLanguageChange);
        i18n.on('languageChanged', loadProducts);

        // 清理监听器
        return () => {
            i18n.off('languageChanged', loadProducts);
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    const handleProductClick = route => {
        navigate(route); // Using navigate for navigation
    };

    return (
        <>
        <SEO
            pageKey="home"
            title={PAGE_SEO.home.title}
            description={PAGE_SEO.home.description}
            keywords={COMMON_KEYWORDS}
            slug={PAGE_SEO.home.slug}
        />
        <div className="home">
            <div className="container">
                <ProductHeader/>
                {/* 2026 秋季推文入口 —— 官网内的推文页 /autumn-2026/ */}
                <a
                    className="autumn-banner"
                    href={`${LANG_PREFIX[i18n.language] || ''}/autumn-2026/`}
                    onClick={(e) => {
                        e.preventDefault();
                        navigate(`${LANG_PREFIX[i18n.language] || ''}/autumn-2026/`);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                >
                    <div className="autumn-banner__tag">{t('autumn_banner_tag')}</div>
                    <div className="autumn-banner__body">
                        <div className="autumn-banner__title">{t('autumn_banner_title')}</div>
                        <div className="autumn-banner__desc">{t('autumn_banner_desc')}</div>
                    </div>
                    <span className="autumn-banner__cta">
                        {t('autumn_banner_cta')}<i>→</i>
                    </span>
                </a>
                <Row gutter={16}>
                    {products.map((product, index) => (
                        <Col key={index} xs={24} sm={12} md={8}>
                                <ProductCard
                                    product={product}
                                    cardStyle={{ height: `${cardHeight}px` }}
                                    onClick={handleProductClick}
                                />
                        </Col>
                    ))}
                </Row>
                <div className="videoPlayer">
                    <Carousel
                        arrows
                        autoplay
                        className="video-carousel"
                        dotPosition="bottom"
                        afterChange={(current) => {
                            videoRefs.current.forEach((el, i) => {
                                if (el && i !== current && el.stopVideo) {
                                    el.stopVideo();
                                }
                            });
                        }}
                    >
                        <VideoPlayerCard
                            src="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video1.mp4"
                            poster="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_3.png"
                            title={t('home_video_x5_title')}
                            ref={(el) => (videoRefs.current[0] = el)}
                        />
                        <VideoPlayerCard
                            src="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video2.mp4"
                            poster="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/x6_intro_1.png"
                            title={t('home_video_x6_title')}
                            ref={(el) => (videoRefs.current[1] = el)}
                        />
                        <VideoPlayerCard
                            src="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/videos/video3.mp4"
                            poster="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/thumbnail/company_intro_1.png"
                            title={t('home_video_zm_title')}
                            ref={(el) => (videoRefs.current[2] = el)}
                        />
                    </Carousel>
                </div>

                <div className="module">
                    <ModuleHeader/>
                    <div className="module-title">{t('equipment_module')}</div>
                    <div className="textAlignLeft"><img className="module_img"
                                                        src="/files/images/module1.png"
                                                        alt="industry1"/></div>
                </div>
                <IndustrySection/>

                <InfoBanner/>

                <div className="advantage">
                    <AdvantageHeader/>
                    <AdvantageDisplay/>
                </div>

                <div className="home-about">
                    <div className="about-inner">
                        <div className="about-header">
                            <div className="about-header-tag">XIAOMAI</div>
                            <h2>{t('aboutXM')}</h2>
                            <div className="about-header-line" />
                        </div>
                        <div className="about-body">
                            <div className="about-img-col">
                                <div className="about-img-frame">
                                    <img
                                        className="about-main-img"
                                        src="/files/images/company.png"
                                        alt="company"
                                    />
                                    <div className="about-img-badge">
                                        <span>XIAOMAI TECH</span>
                                    </div>
                                </div>
                            </div>
                            <div className="about-content-col">
                                <div className="about-kpi-row">
                                    <div className="about-kpi">
                                        <div className="about-kpi-num">1.2<span className="about-kpi-unit">亿</span></div>
                                        <div className="about-kpi-label">{t('kpi_investment')}</div>
                                    </div>
                                    <div className="about-kpi">
                                        <div className="about-kpi-num">15000<span className="about-kpi-unit">m²</span></div>
                                        <div className="about-kpi-label">{t('kpi_production_area')}</div>
                                    </div>
                                    <div className="about-kpi">
                                        <div className="about-kpi-num">2012</div>
                                        <div className="about-kpi-label">{t('kpi_est_year')}</div>
                                    </div>
                                </div>
                                <div className="about-text-block">
                                    <p>{t('aboutXMDesc')}</p>
                                    <p>{t('aboutXMContent')}</p>
                                </div>
                                <div className="about-equipment">
                                    {['激光切割', '折弯机', '自动焊接', '喷涂', '抛丸机'].map(eq => (
                                        <div key={eq} className="about-equip-item">
                                            <div className="about-equip-dot" />
                                            <span>{eq}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="partners">
                    <PartnersHeader/>
                    <PartnerCarousel/>
                </div>

                <div className="inside-info">
                    <InsideInfo/>
                </div>

            </div>
        </div>
        </>
    );
}
